import type { ColorRangeType } from '@ardoq/api-types';

const COLOR_RANGE_MODE_LIMITS: {
  [key in ColorRangeType]: { min: number; max: number };
} = {
  percent: { min: 0, max: 100 },
  percentile: { min: 1, max: 99 },
  number: { min: -Infinity, max: Infinity },
};

export const getColorRangeModeLimits = (
  mode: ColorRangeType
): { min: number; max: number } => COLOR_RANGE_MODE_LIMITS[mode];
